<template>
    <div v-if="feedback.length">
        <v-alert
            v-for="(alert, indexA) in feedback"
            :key="indexA"
            :class="[`${alert.color}--text`, 'py-3']"
            :style="alert.style"
            border="bottom"
        >
            <div
                v-for="(text, indexT) in alert.texts"
                :key="indexT"
                class="d-flex align-center"
            >
                <v-icon v-text="`$${alert.color}`" class="mr-4" :color="alert.color"/>
                <span v-html="text"/>
            </div>

            <template #append>
                <cp-icon-button
                    class="ml-4"
                    icon="$close"
                    size="small"
                    :color="alert.color"
                    @click="closed.push(alert.type)"
                />
            </template>
        </v-alert>
    </div>
</template>

<script>
import hexToRgba from 'hexToRgba';

export default {
    data: () => ({
        closed: [],
    }),
    methods: {
        getFeedback(type) {
            let texts = type == 'alert'
                    ? [this.getAlert()['message']]
                    : this.getError()

            let color = type == 'alert'
                ? this.getAlert()['type']
                : type

            return {
                texts: texts,
                style: {
                    'background-color': hexToRgba.call(this, color),
                    'border-color': `var(--v-${color}-base)`
                },
                color,
                type,
            };
        },
    },
    computed: {
        feedback() {
            const types = ['error', 'alert'];
            let feedback = [];

            types
                .filter(type => !this.closed.includes(type))
                .forEach((type) => {
                    let hasMessage = type == 'alert'
                        ? this.hasAlert()
                        : this.hasErrorMessage()

                    if (!hasMessage) return;

                    feedback.push(this.getFeedback(type));
                });

            return feedback;
        },
    },
}
</script>

<style scoped lang="scss">
.v-alert {
    font-family: 'Inter', sans-serif;
    font-size: 16px;
    font-weight: 500;
    line-height: 170%;
}
</style>
